import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Cover} from "..";
import image from "../../../../../assets/daniel-leone-v7daTKlZzaw-unsplash.jpg";
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    h2: "h2",
    p: "p",
    pre: "pre",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(Cover, {
      metadata: image,
      img: {
        src: image.src
      },
      sources: []
    }), "\n", _jsx(_components.h1, {
      children: "Cover"
    }), "\n", _jsx(_components.p, {
      children: "The Cover component is an image that is displayed full-width. Use it above the first h1 heading on the page."
    }), "\n", _jsx(_components.h2, {
      children: "Usage"
    }), "\n", _jsxs(_components.p, {
      children: ["Use the ", _jsx(_components.code, {
        children: "importImage()"
      }), " macro from the ", _jsx(_components.code, {
        children: "\"@zhif/macro\""
      }), " package to load the image."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { Cover } from \"timvir/blocks\";\nimport { importImage } from \"@zhif/macro\";\n\n<Cover {...importImage(\"path/to/image.jpg\")} />;\n"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
